import React from 'react';
import './OurStory.css';
import ContentSection from '../components/ContentSection';
import Sponsorships from '../components/Sponsorships';

const OurStory = () => {
  return (
    <div className="our-story-page">
      <div className="our-story">
        <h1 className="main-title">A Legacy of Good Living</h1>
        
        <div className="history-section">
          <div className="history-content">
            <h2 className="history-title">Our History</h2>
            <p className="history-text">
            Drake’s is named in honor of Mr. Frederick Drake, known as “The Father of San Carlos”. 

The historic walls of this Spanish style building housed Drake’s real estate office in the early 1900s where he promoted the development and expansion of San	Carlos. 

It was Frederick Drake who coined the slogan:
“The City of Good Living”.
            </p>
          </div>
        </div>

        <Sponsorships />

        {/* <ContentSection
          title="Satisfy Your Food Cravings at Drake's"
          description="Whether you're craving something hearty, fresh, or indulgent, Drake's San Carlos has the perfect dish to satisfy your appetite. From vibrant breakfasts to comforting dinners, each meal is crafted to hit the spot and keep you coming back for more."
          image={satisfyFoodCravings}
          imageAlt="Delicious breakfast tacos with scrambled eggs, bacon, avocado, and cilantro"
          imageOnRight={true}
        /> */}
      </div>
    </div>
  );
};

export default OurStory; 